import React, { memo, useCallback } from 'react';
import { createPortal } from 'react-dom';
import * as styles from './PhonePopup.module.scss';
import { getSmsHref } from './helpers';

const PhonePopup = ({ phoneNumber, onClose }) => {
  const onOverlayClick = useCallback(() => onClose?.(), [onClose]);

  const onSheetClick = useCallback((e) => e.stopPropagation(), []);

  if (typeof document === 'undefined' || !phoneNumber) {
    return null;
  }

  const popupContent = (
    <div className={styles.phonePopupOverlay} onClick={onOverlayClick}>
      <div className={styles.phonePopupSheet} onClick={onSheetClick}>
        <a
          className={`${styles.phonePopupButton} ${styles.phonePopupTextButton}`}
          href={getSmsHref(phoneNumber)}
        >
          Text {phoneNumber}
        </a>

        <button
          type="button"
          className={`${styles.phonePopupButton} ${styles.phonePopupCancelButton}`}
          onClick={onOverlayClick}
        >
          Cancel
        </button>
      </div>
    </div>
  );

  return createPortal(popupContent, document.body);
};

export default memo(PhonePopup);
